<app-audit-timeline-view *ngIf="getSubType() == 'View'" [audits]="getItems()"></app-audit-timeline-view>
<app-audit-timeline-search *ngIf="getSubType() == 'Search'" [audits]="getItems()"></app-audit-timeline-search>
<app-audit-timeline-modification *ngIf="getSubType() == 'Modification'" [audits]="getItems()"></app-audit-timeline-modification>
<ng-container *ngIf="getSubType() == 'Group'">
	<ng-container *ngFor="let item of getItems()">
		<app-audit-timeline-group [audit]="getAsGroup(item)"></app-audit-timeline-group>
	</ng-container>
</ng-container>
<ng-container *ngIf="getSubType() == 'Mixed'">
	<ng-container *ngFor="let item of getItems()">
		<app-audit-timeline-group [audit]="getAsGroup(item)"></app-audit-timeline-group>
	</ng-container>
</ng-container>
